import vueAPI from '@/modules/vueAPI.js'
import { createStore } from 'vuex'

import loginData from './modules/loginData.js'
import menuControl from './modules/menuControl.js'
import socket from './modules/socketIO.js'
import myData from './modules/myData.js'
import globalData from './modules/globalData.js'

export default createStore({
    state: {
        dateNow: new Date(),
        languages: {}
    },
    modules: {
        loginData,
        menuControl,
        socket,
        myData,
        globalData
    }
})

setInterval(() => {
    vueAPI.onMounted((thisVue) => {
        thisVue.$store.state.dateNow = new Date()
    })
}, (1000 * 10));